// extracted by mini-css-extract-plugin
export default {"accordion":"C8i2Cj","accordion-panel":"S1e03w"};